// ============================================================
//  Apex Legends Rank Boost Calculator – v4
//  assets/apex-calculator.js
// ============================================================

(function () {
  'use strict';

  // ── Produkt-Handles ────────────────────────────────────────
  const PRODUCT_HANDLES = [
    'apex-boost-bronze',
    'apex-boost-silber',
    'apex-boost-gold-platin',
    'apex-boost-diamant',
  ];

  // ── Rang-Konfiguration ─────────────────────────────────────
  const RANKS = ['Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond', 'Master'];
  const NO_DIV = ['Master'];

  const RANK_SVG = {
    Bronze: `<svg viewBox="0 0 100 100" width="36" height="36" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="46" fill="#1a0d00" stroke="#7a4010" stroke-width="1.5"/>
      <circle cx="50" cy="50" r="40" fill="#120900" stroke="#cd7f32" stroke-width="2"/>
      <circle cx="50" cy="50" r="34" fill="#1a0d00" stroke="#a05820" stroke-width="0.8"/>
      <path d="M36,87 L50,96 L64,87" fill="#1a0d00" stroke="#cd7f32" stroke-width="1.5"/>
      <path d="M50,27 L70,67 L64,67 L50,39 L36,67 L30,67 Z" fill="#cd7f32"/>
      <path d="M40,67 L50,47 L60,67 Z" fill="#120900"/>
    </svg>`,
    Silver: `<svg viewBox="0 0 100 100" width="36" height="36" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="46" fill="#0d0d12" stroke="#606068" stroke-width="1.5"/>
      <circle cx="50" cy="50" r="40" fill="#0a0a10" stroke="#a8a9ad" stroke-width="2"/>
      <circle cx="50" cy="50" r="34" fill="#0d0d12" stroke="#707078" stroke-width="0.8"/>
      <rect x="46" y="5" width="8" height="6" rx="1" fill="#a8a9ad"/>
      <path d="M36,87 L50,96 L64,87" fill="#0d0d12" stroke="#a8a9ad" stroke-width="1.5"/>
      <path d="M50,27 L70,67 L64,67 L50,39 L36,67 L30,67 Z" fill="#a8a9ad"/>
      <path d="M40,67 L50,47 L60,67 Z" fill="#0a0a10"/>
    </svg>`,
    Gold: `<svg viewBox="0 0 100 100" width="36" height="36" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="46" fill="#1a1000" stroke="#806000" stroke-width="1.5"/>
      <circle cx="50" cy="50" r="40" fill="#120c00" stroke="#ffd700" stroke-width="2.5"/>
      <circle cx="50" cy="50" r="34" fill="#1a1000" stroke="#c09000" stroke-width="0.8"/>
      <rect x="46" y="5" width="8" height="7" rx="1" fill="#ffd700"/>
      <rect x="34" y="8" width="5" height="5" rx="1" fill="#ffd700" opacity="0.6"/>
      <rect x="61" y="8" width="5" height="5" rx="1" fill="#ffd700" opacity="0.6"/>
      <path d="M34,88 L50,98 L66,88" fill="#1a1000" stroke="#ffd700" stroke-width="2"/>
      <path d="M50,25 L72,69 L65,69 L50,37 L35,69 L28,69 Z" fill="#ffd700"/>
      <path d="M39,69 L50,45 L61,69 Z" fill="#120c00"/>
    </svg>`,
    Platinum: `<svg viewBox="0 0 100 100" width="36" height="36" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="46" fill="#001030" stroke="#1a5080" stroke-width="1.5"/>
      <circle cx="50" cy="50" r="40" fill="#000820" stroke="#b9f2ff" stroke-width="2"/>
      <circle cx="50" cy="50" r="34" fill="#001030" stroke="#4090b0" stroke-width="0.8"/>
      <path d="M8,40 L2,50 L8,60 L14,57 L10,50 L14,43 Z" fill="#b9f2ff" opacity="0.8"/>
      <path d="M92,40 L98,50 L92,60 L86,57 L90,50 L86,43 Z" fill="#b9f2ff" opacity="0.8"/>
      <polygon points="50,5 46,11 50,4 54,11" fill="#b9f2ff"/>
      <path d="M30,29 L50,63 L70,29 L64,29 L50,55 L36,29 Z" fill="#b9f2ff"/>
      <path d="M36,29 L50,53 L64,29 L58,29 L50,43 L42,29 Z" fill="#000820"/>
    </svg>`,
    Diamond: `<svg viewBox="0 0 100 100" width="36" height="36" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="46" fill="#001520" stroke="#1a6090" stroke-width="1.5"/>
      <circle cx="50" cy="50" r="40" fill="#001020" stroke="#4db8ff" stroke-width="2"/>
      <circle cx="50" cy="50" r="34" fill="#001520" stroke="#2080b0" stroke-width="0.8"/>
      <path d="M8,38 L0,50 L8,62 L16,58 L10,50 L16,42 Z" fill="#4db8ff" opacity="0.9"/>
      <path d="M92,38 L100,50 L92,62 L84,58 L90,50 L84,42 Z" fill="#4db8ff" opacity="0.9"/>
      <polygon points="50,3 46,10 50,2 54,10" fill="#4db8ff"/>
      <polygon points="40,6 37,12 40,5 43,12" fill="#4db8ff" opacity="0.6"/>
      <polygon points="60,6 57,12 60,5 63,12" fill="#4db8ff" opacity="0.6"/>
      <path d="M50,25 L72,69 L65,69 L50,37 L35,69 L28,69 Z" fill="#4db8ff"/>
      <path d="M39,69 L50,45 L61,69 Z" fill="#001020"/>
      <polygon points="50,21 54,27 50,25 46,27" fill="#80d8ff"/>
    </svg>`,
    Master: `<svg viewBox="0 0 100 100" width="36" height="36" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="46" fill="#0d0018" stroke="#5a1080" stroke-width="1.5"/>
      <circle cx="50" cy="50" r="40" fill="#080012" stroke="#9b59b6" stroke-width="2.5"/>
      <circle cx="50" cy="50" r="34" fill="#0d0018" stroke="#7030a0" stroke-width="0.8"/>
      <polygon points="50,3 47,11 50,1 53,11" fill="#d8a0ff"/>
      <polygon points="38,6 35,13 38,5 41,13" fill="#d8a0ff" opacity="0.7"/>
      <polygon points="62,6 59,13 62,5 65,13" fill="#d8a0ff" opacity="0.7"/>
      <polygon points="28,12 25,18 28,11 31,18" fill="#9b59b6" opacity="0.5"/>
      <polygon points="72,12 69,18 72,11 75,18" fill="#9b59b6" opacity="0.5"/>
      <path d="M50,25 L72,69 L65,69 L50,37 L35,69 L28,69 Z" fill="#d8a0ff"/>
      <path d="M39,69 L50,45 L61,69 Z" fill="#080012"/>
      <circle cx="50" cy="50" r="38" fill="none" stroke="#d8a0ff" stroke-width="0.5" opacity="0.4"/>
    </svg>`,
  };

  const RANK_META = {
    Bronze:   { svg: RANK_SVG.Bronze,   color: '#cd7f32', colorBg: 'rgba(205,127,50,0.12)',   de: 'Bronze'  },
    Silver:   { svg: RANK_SVG.Silver,   color: '#a8a9ad', colorBg: 'rgba(168,169,173,0.12)', de: 'Silber'  },
    Gold:     { svg: RANK_SVG.Gold,     color: '#ffd700', colorBg: 'rgba(255,215,0,0.12)',    de: 'Gold'    },
    Platinum: { svg: RANK_SVG.Platinum, color: '#b9f2ff', colorBg: 'rgba(185,242,255,0.12)',  de: 'Platin'  },
    Diamond:  { svg: RANK_SVG.Diamond,  color: '#4db8ff', colorBg: 'rgba(77,184,255,0.12)',   de: 'Diamant' },
    Master:   { svg: RANK_SVG.Master,   color: '#9b59b6', colorBg: 'rgba(155,89,182,0.12)',   de: 'Master'  },
  };

  const RANK_ORDER = [];
  ['Bronze','Silver','Gold','Platinum','Diamond'].forEach(r => {
    [4,3,2,1].forEach(d => RANK_ORDER.push({ rank: r, div: d }));
  });
  RANK_ORDER.push({ rank: 'Master', div: 0 });

  const DIV_LABEL = { 4:'IV', 3:'III', 2:'II', 1:'I' };

  function rankIndex(rank, div) {
    return RANK_ORDER.findIndex(r => r.rank === rank && r.div === div);
  }

  function rankKey(rank, div) {
    return div > 0 ? `${rank}${div}` : rank;
  }

  function rankLabelDE(rank, div) {
    const name = RANK_META[rank].de;
    return div > 0 ? `${name} ${DIV_LABEL[div]}` : name;
  }

  // ── State ──────────────────────────────────────────────────
  const state = {
    from:        { rank: null, div: null },
    to:          { rank: null, div: null },
    addons:      new Set(),
    variantData: {},
    loaded:      false,
  };

  // ── Init ───────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', async () => {
    if (!document.getElementById('apex-boost-calc')) return;
    renderRankGrids('from');
    renderRankGrids('to');
    renderAddons();
    document.getElementById('ac-btn').addEventListener('click', handleCheckout);
    await loadAllVariants();
  });

  // ── Varianten laden ────────────────────────────────────────
  async function loadAllVariants() {
    showLoadingState(true);
    try {
      const results = await Promise.all(
        PRODUCT_HANDLES.map(handle =>
          fetch(`/products/${handle}.js`)
            .then(r => {
              if (!r.ok) throw new Error(`Produkt nicht gefunden: ${handle}`);
              return r.json();
            })
        )
      );
      results.forEach(product => {
        product.variants.forEach(variant => {
          if (variant.sku) {
            state.variantData[variant.sku] = {
              variantId: variant.id,
              price:     variant.price / 100,
            };
          }
        });
      });
      state.loaded = true;
      console.log(`[ApexBoost] ${Object.keys(state.variantData).length} Varianten geladen ✓`);
    } catch (err) {
      console.error('[ApexBoost] Fehler beim Laden der Varianten:', err);
      showError('Produkte konnten nicht geladen werden. Bitte Seite neu laden.');
    }
    showLoadingState(false);
  }

  function showLoadingState(loading) {
    const btn = document.getElementById('ac-btn');
    const btnText = document.getElementById('ac-btn-text');
    if (loading) {
      btn.disabled = true;
      btnText.textContent = 'Lädt…';
    } else {
      btnText.textContent = 'Rang auswählen';
    }
  }

  function showError(msg) {
    const el = document.getElementById('ac-price-label');
    if (el) el.textContent = msg;
  }

  // ── Rang-Grids rendern ─────────────────────────────────────
  function renderRankGrids(panel) {
    const grid = document.getElementById(`ac-ranks-${panel}`);
    grid.innerHTML = '';
    RANKS.forEach(rank => {
      const meta = RANK_META[rank];
      const btn = document.createElement('button');
      btn.className = 'ac-rank-btn';
      btn.dataset.rank = rank;
      btn.dataset.panel = panel;
      btn.style.setProperty('--rc', meta.color);
      btn.style.setProperty('--rcbg', meta.colorBg);
      btn.innerHTML = `
        <span class="ac-rank-icon">${meta.svg}</span>
        <span class="ac-rank-name">${meta.de}</span>
      `;
      btn.addEventListener('click', () => selectRank(panel, rank));
      grid.appendChild(btn);
    });
  }

  function renderDivisions(panel) {
    const row = document.getElementById(`ac-divs-${panel}`);
    const { rank, div } = state[panel];
    if (!rank || NO_DIV.includes(rank)) {
      row.innerHTML = '';
      row.style.display = 'none';
      return;
    }
    row.style.display = 'flex';
    row.innerHTML = '';
    [4,3,2,1].forEach(num => {
      const btn = document.createElement('button');
      btn.className = `ac-div-btn${div === num ? ' active' : ''}`;
      btn.textContent = DIV_LABEL[num];
      btn.addEventListener('click', () => selectDiv(panel, num));
      row.appendChild(btn);
    });
  }

  // ── Auswahl ────────────────────────────────────────────────
  function selectRank(panel, rank) {
    state[panel].rank = rank;
    state[panel].div  = NO_DIV.includes(rank) ? 0 : 4;
    document.querySelectorAll(`.ac-rank-btn[data-panel="${panel}"]`).forEach(b => {
      b.classList.toggle('active', b.dataset.rank === rank);
    });
    renderDivisions(panel);
    recalculate();
  }

  function selectDiv(panel, num) {
    state[panel].div = num;
    document.querySelectorAll(`#ac-divs-${panel} .ac-div-btn`).forEach((b, i) => {
      b.classList.toggle('active', [4,3,2,1][i] === num);
    });
    recalculate();
  }

  // ── Step-basierte Preisberechnung ──────────────────────────
  function calcStepPrice(fromIdx, toIdx) {
    if (toIdx <= fromIdx) return null;
    const steps = window.APEX_STEP_PRICES;
    if (!steps) return null;
    let total = 0;
    for (let i = fromIdx; i < toIdx; i++) {
      const fr = RANK_ORDER[i];
      const tr = RANK_ORDER[i + 1];
      const frKey = fr.div > 0 ? `${fr.rank}${fr.div}` : fr.rank;
      const trKey = tr.div > 0 ? `${tr.rank}${tr.div}` : tr.rank;
      const key = `${frKey}_${trKey}`;
      const p = steps[key];
      if (p === undefined) return null;
      total += p;
    }
    return total;
  }

  function basePrice() {
    const { from, to } = state;
    if (!from.rank || !to.rank) return null;
    const fromIdx = rankIndex(from.rank, from.div);
    const toIdx   = rankIndex(to.rank,   to.div);
    return calcStepPrice(fromIdx, toIdx);
  }

  function totalPrice() {
    const base = basePrice();
    if (base === null) return null;
    let total = base;
    state.addons.forEach(id => {
      const addon = window.APEX_ADDONS.find(a => a.id === id);
      if (!addon) return;
      total += addon.type === 'flat'
        ? addon.value
        : Math.round(base * addon.value / 100 * 100) / 100;
    });
    return total;
  }

  // ── Preisberechnung ────────────────────────────────────────
  function recalculate() {
    if (!state.loaded) return;
    const { from, to } = state;
    if (!from.rank || !to.rank) { setPriceState('idle'); return; }
    const fromIdx = rankIndex(from.rank, from.div);
    const toIdx   = rankIndex(to.rank,   to.div);
    if (toIdx <= fromIdx) { setPriceState('invalid'); return; }
    const price = calcStepPrice(fromIdx, toIdx);
    if (price === null) { setPriceState('unavail'); return; }
    setPriceState('ready', price);
    updateSummary(price);
  }

  function setPriceState(mode, price) {
    const priceEl = document.getElementById('ac-price-display');
    const labelEl = document.getElementById('ac-price-label');
    const btn     = document.getElementById('ac-btn');
    const btnText = document.getElementById('ac-btn-text');
    const summary = document.getElementById('ac-summary');

    switch (mode) {
      case 'idle':
        priceEl.textContent = '—';
        labelEl.textContent = 'Rang wählen';
        btn.disabled = true;
        btnText.textContent = 'Rang auswählen';
        summary.style.display = 'none';
        break;
      case 'invalid':
        priceEl.textContent = '⚠';
        labelEl.textContent = 'Ziel muss höher sein';
        btn.disabled = true;
        btnText.textContent = 'Ziel-Rang muss höher sein';
        summary.style.display = 'none';
        break;
      case 'unavail':
        priceEl.textContent = 'N/A';
        labelEl.textContent = 'Nicht verfügbar';
        btn.disabled = true;
        btnText.textContent = 'Nicht verfügbar';
        summary.style.display = 'none';
        break;
      case 'ready':
        animatePrice(priceEl, price);
        labelEl.textContent = 'Gesamtpreis';
        btn.disabled = false;
        btnText.textContent = 'Jetzt boosten ⚡';
        summary.style.display = 'block';
        break;
    }
  }

  function animatePrice(el, target) {
    const start = parseFloat(el.textContent) || 0;
    const steps = 20;
    let i = 0;
    const iv = setInterval(() => {
      i++;
      el.textContent = (start + (target - start) * (i / steps)).toFixed(2);
      if (i >= steps) { el.textContent = target.toFixed(2); clearInterval(iv); }
    }, 16);
  }

  // ── Add-ons rendern ────────────────────────────────────────
  function renderAddons() {
    const grid = document.getElementById('ac-addons-grid');
    if (!grid || !window.APEX_ADDONS) return;
    window.APEX_ADDONS.forEach(addon => {
      const priceLabel = addon.value === 0 ? 'Kostenlos'
        : addon.type === 'percent' ? `+${addon.value}%`
        : `+${addon.value.toFixed(2)} €`;
      const card = document.createElement('div');
      card.className = 'ac-addon-card';
      card.innerHTML = `
        <div class="ac-addon-left">
          <span class="ac-addon-icon">${addon.icon}</span>
          <div class="ac-addon-text">
            <span class="ac-addon-label">${addon.label}</span>
            <span class="ac-addon-desc">${addon.desc}</span>
          </div>
        </div>
        <div class="ac-addon-right">
          <span class="ac-addon-price">${priceLabel}</span>
          <label class="ac-toggle">
            <input type="checkbox" data-addon-id="${addon.id}">
            <span class="ac-toggle-track"><span class="ac-toggle-thumb"></span></span>
          </label>
        </div>
      `;
      const checkbox = card.querySelector('input');
      checkbox.addEventListener('change', () => {
        if (checkbox.checked) { state.addons.add(addon.id); card.classList.add('selected'); }
        else { state.addons.delete(addon.id); card.classList.remove('selected'); }
        const base = basePrice();
        if (base !== null) updateSummary(base);
      });
      card.addEventListener('click', e => { if (e.target !== checkbox) checkbox.click(); });
      grid.appendChild(card);
    });
  }

  // ── Zusammenfassung ────────────────────────────────────────
  function updateSummary(base) {
    document.getElementById('ac-sum-base').textContent = `${base.toFixed(2)} €`;
    const addonsContainer = document.getElementById('ac-sum-addons');
    addonsContainer.innerHTML = '';
    let addonsTotal = 0;
    state.addons.forEach(id => {
      const addon = window.APEX_ADDONS.find(a => a.id === id);
      if (!addon) return;
      const cost = addon.type === 'flat'
        ? addon.value
        : Math.round(base * addon.value / 100 * 100) / 100;
      addonsTotal += cost;
      const label = cost === 0 ? 'Kostenlos' : `+${cost.toFixed(2)} €`;
      addonsContainer.innerHTML += `
        <div class="ac-summary-row addon-row">
          <span>${addon.icon} ${addon.label}</span>
          <span>${label}</span>
        </div>`;
    });
    document.getElementById('ac-sum-total').textContent =
      `${(base + addonsTotal).toFixed(2)} €`;
  }

  // ── Checkout ───────────────────────────────────────────────
  async function handleCheckout() {
    const { from, to } = state;
    const base = basePrice();
    if (!base) return;

    const btn     = document.getElementById('ac-btn');
    const btnText = document.getElementById('ac-btn-text');
    btn.disabled = true;
    btnText.textContent = 'Wird hinzugefügt…';

    const fromLabel = rankLabelDE(from.rank, from.div);
    const toLabel   = rankLabelDE(to.rank, to.div);

    const sku = `${rankKey(from.rank, from.div)}_to_${rankKey(to.rank, to.div)}`;
    const variant = state.variantData[sku];

    if (!variant) {
      btn.disabled = false;
      btnText.textContent = 'Fehler – Variante nicht gefunden';
      return;
    }

    const items = [
      {
        id:       variant.variantId,
        quantity: 1,
        properties: {
          'Von Rang':    fromLabel,
          'Ziel-Rang':   toLabel,
          'Boost-Preis': `${base.toFixed(2)} EUR`,
        }
      }
    ];

    state.addons.forEach(id => {
      const addon = window.APEX_ADDONS.find(a => a.id === id);
      const varId = window.APEX_ADDON_VARIANTS?.[id];
      if (!addon || !varId) return;
      const cost = addon.type === 'flat'
        ? addon.value
        : Math.round(base * addon.value / 100 * 100) / 100;
      items.push({
        id:       varId,
        quantity: 1,
        properties: {
          'Für Boost': `${fromLabel} → ${toLabel}`,
          'Aufpreis':  cost === 0 ? 'Kostenlos' : `${cost.toFixed(2)} EUR`,
        }
      });
    });

    try {
      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ items }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Cart-Fehler');
      }
      window.location.href = '/checkout';
    } catch (err) {
      console.error('[ApexBoost] Checkout-Fehler:', err);
      btn.disabled = false;
      btnText.textContent = 'Fehler – erneut versuchen';
    }
  }

})();